module.exports = __webpack_public_path__ + "static/media/NewOrderColor.a82cffff.svg";